var cov_gvol7406u = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/tiled.tsx",
      hash = "8da78e901bb811101b05cdc7264b829f191d396c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/tiled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 21
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 23,
          column: 38
        }
      },
      "2": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 18
        }
      },
      "3": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 35,
          column: 7
        }
      },
      "4": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "5": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 54
        }
      },
      "6": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 52
        }
      },
      "7": {
        start: {
          line: 38,
          column: 34
        },
        end: {
          line: 38,
          column: 52
        }
      },
      "8": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 46,
          column: 7
        }
      },
      "9": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 44,
          column: 31
        }
      },
      "10": {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 43,
          column: 68
        }
      },
      "11": {
        start: {
          line: 44,
          column: 13
        },
        end: {
          line: 44,
          column: 31
        }
      },
      "12": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 26
        }
      },
      "13": {
        start: {
          line: 50,
          column: 38
        },
        end: {
          line: 50,
          column: 48
        }
      },
      "14": {
        start: {
          line: 51,
          column: 19
        },
        end: {
          line: 51,
          column: 48
        }
      },
      "15": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 91
        }
      },
      "16": {
        start: {
          line: 52,
          column: 66
        },
        end: {
          line: 52,
          column: 91
        }
      },
      "17": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 57,
          column: 8
        }
      },
      "18": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "19": {
        start: {
          line: 62,
          column: 45
        },
        end: {
          line: 62,
          column: 55
        }
      },
      "20": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 71
        }
      },
      "21": {
        start: {
          line: 64,
          column: 18
        },
        end: {
          line: 64,
          column: 44
        }
      },
      "22": {
        start: {
          line: 65,
          column: 22
        },
        end: {
          line: 65,
          column: 52
        }
      },
      "23": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "24": {
        start: {
          line: 66,
          column: 29
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "25": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 70,
          column: 103
        }
      },
      "26": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 57
        }
      },
      "27": {
        start: {
          line: 71,
          column: 40
        },
        end: {
          line: 71,
          column: 57
        }
      },
      "28": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 76,
          column: 7
        }
      },
      "29": {
        start: {
          line: 80,
          column: 27
        },
        end: {
          line: 80,
          column: 37
        }
      },
      "30": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 46
        }
      },
      "31": {
        start: {
          line: 81,
          column: 17
        },
        end: {
          line: 81,
          column: 46
        }
      },
      "32": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 40
        }
      },
      "33": {
        start: {
          line: 82,
          column: 20
        },
        end: {
          line: 82,
          column: 40
        }
      },
      "34": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 25
        }
      },
      "35": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 93,
          column: 7
        }
      },
      "36": {
        start: {
          line: 89,
          column: 24
        },
        end: {
          line: 89,
          column: 49
        }
      },
      "37": {
        start: {
          line: 90,
          column: 10
        },
        end: {
          line: 91,
          column: 37
        }
      },
      "38": {
        start: {
          line: 90,
          column: 26
        },
        end: {
          line: 90,
          column: 55
        }
      },
      "39": {
        start: {
          line: 91,
          column: 15
        },
        end: {
          line: 91,
          column: 37
        }
      },
      "40": {
        start: {
          line: 97,
          column: 74
        },
        end: {
          line: 97,
          column: 84
        }
      },
      "41": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 86
        }
      },
      "42": {
        start: {
          line: 102,
          column: 47
        },
        end: {
          line: 102,
          column: 57
        }
      },
      "43": {
        start: {
          line: 103,
          column: 25
        },
        end: {
          line: 103,
          column: 35
        }
      },
      "44": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 104,
          column: 77
        }
      },
      "45": {
        start: {
          line: 104,
          column: 44
        },
        end: {
          line: 104,
          column: 77
        }
      },
      "46": {
        start: {
          line: 105,
          column: 26
        },
        end: {
          line: 105,
          column: 54
        }
      },
      "47": {
        start: {
          line: 106,
          column: 26
        },
        end: {
          line: 106,
          column: 49
        }
      },
      "48": {
        start: {
          line: 107,
          column: 19
        },
        end: {
          line: 107,
          column: 79
        }
      },
      "49": {
        start: {
          line: 108,
          column: 20
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "50": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 34
        }
      },
      "51": {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 117,
          column: 14
        }
      },
      "52": {
        start: {
          line: 120,
          column: 34
        },
        end: {
          line: 125,
          column: 1
        }
      },
      "53": {
        start: {
          line: 120,
          column: 119
        },
        end: {
          line: 125,
          column: 1
        }
      },
      "54": {
        start: {
          line: 123,
          column: 41
        },
        end: {
          line: 123,
          column: 46
        }
      },
      "55": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 124,
          column: 115
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 21
          },
          end: {
            line: 22,
            column: 22
          }
        },
        loc: {
          start: {
            line: 22,
            column: 42
          },
          end: {
            line: 118,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        },
        loc: {
          start: {
            line: 31,
            column: 61
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 31
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 41,
            column: 72
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 41
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        loc: {
          start: {
            line: 49,
            column: 23
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        },
        loc: {
          start: {
            line: 61,
            column: 24
          },
          end: {
            line: 77,
            column: 5
          }
        },
        line: 61
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 5
          }
        },
        loc: {
          start: {
            line: 79,
            column: 53
          },
          end: {
            line: 83,
            column: 5
          }
        },
        line: 79
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        loc: {
          start: {
            line: 85,
            column: 51
          },
          end: {
            line: 94,
            column: 5
          }
        },
        line: 85
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 88,
            column: 14
          },
          end: {
            line: 88,
            column: 15
          }
        },
        loc: {
          start: {
            line: 88,
            column: 23
          },
          end: {
            line: 92,
            column: 9
          }
        },
        line: 88
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        },
        loc: {
          start: {
            line: 96,
            column: 18
          },
          end: {
            line: 99,
            column: 5
          }
        },
        line: 96
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        },
        loc: {
          start: {
            line: 101,
            column: 13
          },
          end: {
            line: 115,
            column: 5
          }
        },
        line: 101
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 120,
            column: 34
          },
          end: {
            line: 120,
            column: 35
          }
        },
        loc: {
          start: {
            line: 120,
            column: 119
          },
          end: {
            line: 125,
            column: 1
          }
        },
        line: 120
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 120,
            column: 119
          },
          end: {
            line: 120,
            column: 120
          }
        },
        loc: {
          start: {
            line: 122,
            column: 5
          },
          end: {
            line: 125,
            column: 1
          }
        },
        line: 122
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 23,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 26
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 52
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 52
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }],
        line: 42
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 10
          },
          end: {
            line: 42,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 10
          },
          end: {
            line: 42,
            column: 50
          }
        }, {
          start: {
            line: 42,
            column: 54
          },
          end: {
            line: 42,
            column: 81
          }
        }],
        line: 42
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 44,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 44,
            column: 31
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 44,
            column: 31
          }
        }],
        line: 43
      },
      "5": {
        loc: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 52,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 52,
            column: 91
          }
        }, {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 52,
            column: 91
          }
        }],
        line: 52
      },
      "6": {
        loc: {
          start: {
            line: 52,
            column: 10
          },
          end: {
            line: 52,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 10
          },
          end: {
            line: 52,
            column: 28
          }
        }, {
          start: {
            line: 52,
            column: 32
          },
          end: {
            line: 52,
            column: 64
          }
        }],
        line: 52
      },
      "7": {
        loc: {
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 32
          }
        }, {
          start: {
            line: 56,
            column: 36
          },
          end: {
            line: 56,
            column: 60
          }
        }],
        line: 56
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 27
          },
          end: {
            line: 62,
            column: 40
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 62,
            column: 38
          },
          end: {
            line: 62,
            column: 40
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 46
          }
        }, {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 46
          }
        }],
        line: 66
      },
      "10": {
        loc: {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 15
          }
        }, {
          start: {
            line: 66,
            column: 19
          },
          end: {
            line: 66,
            column: 27
          }
        }],
        line: 66
      },
      "11": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 70,
            column: 103
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 39
          }
        }, {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 28
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 103
          }
        }],
        line: 68
      },
      "12": {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 57
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 57
          }
        }],
        line: 71
      },
      "13": {
        loc: {
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 73,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 50
          },
          end: {
            line: 73,
            column: 59
          }
        }, {
          start: {
            line: 73,
            column: 63
          },
          end: {
            line: 73,
            column: 69
          }
        }],
        line: 73
      },
      "14": {
        loc: {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 81,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 81,
            column: 46
          }
        }, {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 81,
            column: 46
          }
        }],
        line: 81
      },
      "15": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 40
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 40
          }
        }],
        line: 82
      },
      "16": {
        loc: {
          start: {
            line: 90,
            column: 10
          },
          end: {
            line: 91,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 10
          },
          end: {
            line: 91,
            column: 37
          }
        }, {
          start: {
            line: 90,
            column: 10
          },
          end: {
            line: 91,
            column: 37
          }
        }],
        line: 90
      },
      "17": {
        loc: {
          start: {
            line: 97,
            column: 23
          },
          end: {
            line: 97,
            column: 61
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 97,
            column: 37
          },
          end: {
            line: 97,
            column: 61
          }
        }],
        line: 97
      },
      "18": {
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 77
          }
        }, {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 104,
            column: 77
          }
        }],
        line: 104
      },
      "19": {
        loc: {
          start: {
            line: 104,
            column: 10
          },
          end: {
            line: 104,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 10
          },
          end: {
            line: 104,
            column: 21
          }
        }, {
          start: {
            line: 104,
            column: 25
          },
          end: {
            line: 104,
            column: 42
          }
        }],
        line: 104
      },
      "20": {
        loc: {
          start: {
            line: 124,
            column: 45
          },
          end: {
            line: 124,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 45
          },
          end: {
            line: 124,
            column: 61
          }
        }, {
          start: {
            line: 124,
            column: 65
          },
          end: {
            line: 124,
            column: 73
          }
        }],
        line: 124
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/tiled.tsx",
    _this2 = this;

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import Datum from '../Datum/Tree';
import { curry } from '../utils/func';
import { mergeFilteredTree } from '../utils/tree';
import { treeClass } from '../Tree/styles';
import { treeSelectClass } from './styles';
import { Component } from '../component';
var DefaultProps = (cov_gvol7406u.s[0]++, {
  childrenKey: 'children'
});
export default curry(function (options, Origin) {
  cov_gvol7406u.f[0]++;

  var _ref = (cov_gvol7406u.s[1]++, options),
      _ref$dataKey = _ref.dataKey,
      dataKey = _ref$dataKey === void 0 ? (cov_gvol7406u.b[0][0]++, 'data') : _ref$dataKey;

  var Tiled =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Tiled, _Component);

    var _super = _createSuper2(Tiled);

    function Tiled(props) {
      var _this;

      _classCallCheck(this, Tiled);

      cov_gvol7406u.f[1]++;
      cov_gvol7406u.s[2]++;
      _this = _super.call(this, props);
      _this.rawDatum = void 0;
      _this.filteredDatum = void 0;
      cov_gvol7406u.s[3]++;
      _this.state = {
        tileds: []
      };
      cov_gvol7406u.s[4]++;
      _this.getIcon = _this.getIcon.bind(_assertThisInitialized(_this));
      cov_gvol7406u.s[5]++;
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
      cov_gvol7406u.s[6]++;

      if (props.onAdvancedFilter) {
        cov_gvol7406u.b[1][0]++;
        cov_gvol7406u.s[7]++;

        _this.genRawDatum();
      } else {
        cov_gvol7406u.b[1][1]++;
      }

      return _this;
    }

    _createClass(Tiled, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_gvol7406u.f[2]++;
        cov_gvol7406u.s[8]++;

        if ((cov_gvol7406u.b[3][0]++, prevProps.rawData !== this.props.rawData) && (cov_gvol7406u.b[3][1]++, this.props.onAdvancedFilter)) {
          cov_gvol7406u.b[2][0]++;
          cov_gvol7406u.s[9]++;

          if (this.rawDatum) {
            cov_gvol7406u.b[4][0]++;
            cov_gvol7406u.s[10]++;
            this.rawDatum.setData(this.props.rawData);
          } else {
            cov_gvol7406u.b[4][1]++;
            cov_gvol7406u.s[11]++;
            this.genRawDatum();
          }

          cov_gvol7406u.s[12]++;
          this.forceUpdate();
        } else {
          cov_gvol7406u.b[2][1]++;
        }
      }
    }, {
      key: "getFilteredDatum",
      value: function getFilteredDatum() {
        cov_gvol7406u.f[3]++;

        var _ref2 = (cov_gvol7406u.s[13]++, this.props),
            keygen = _ref2.keygen,
            childrenKey = _ref2.childrenKey;

        var data = (cov_gvol7406u.s[14]++, this.props[dataKey]);
        cov_gvol7406u.s[15]++;

        if ((cov_gvol7406u.b[6][0]++, this.filteredDatum) && (cov_gvol7406u.b[6][1]++, this.filteredDatum.data === data)) {
          cov_gvol7406u.b[5][0]++;
          cov_gvol7406u.s[16]++;
          return this.filteredDatum;
        } else {
          cov_gvol7406u.b[5][1]++;
        }

        cov_gvol7406u.s[17]++;
        this.filteredDatum = new Datum({
          data: data,
          keygen: keygen,
          childrenKey: (cov_gvol7406u.b[7][0]++, childrenKey) || (cov_gvol7406u.b[7][1]++, DefaultProps.childrenKey)
        });
        cov_gvol7406u.s[18]++;
        return this.filteredDatum;
      }
    }, {
      key: "getIcon",
      value: function getIcon(data) {
        cov_gvol7406u.f[4]++;

        var _ref3 = (cov_gvol7406u.s[19]++, this.props),
            childrenKey = _ref3.childrenKey,
            _ref3$expanded = _ref3.expanded,
            expanded = _ref3$expanded === void 0 ? (cov_gvol7406u.b[8][0]++, []) : _ref3$expanded;

        var originIcon = (cov_gvol7406u.s[20]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: treeClass('default-icon'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 63,
            columnNumber: 26
          }
        }));
        var key = (cov_gvol7406u.s[21]++, this.rawDatum.getKey(data));
        var rawData = (cov_gvol7406u.s[22]++, this.rawDatum.getDataById(key));
        cov_gvol7406u.s[23]++;

        if ((cov_gvol7406u.b[10][0]++, !data) || (cov_gvol7406u.b[10][1]++, !rawData)) {
          cov_gvol7406u.b[9][0]++;
          cov_gvol7406u.s[24]++;
          return originIcon;
        } else {
          cov_gvol7406u.b[9][1]++;
        }

        var sameCount = (cov_gvol7406u.s[25]++, (cov_gvol7406u.b[11][0]++, data[childrenKey]) && (cov_gvol7406u.b[11][1]++, rawData[childrenKey]) && (cov_gvol7406u.b[11][2]++, data[childrenKey].length === rawData[childrenKey].length));
        cov_gvol7406u.s[26]++;

        if (expanded.indexOf(key) === -1) {
          cov_gvol7406u.b[12][0]++;
          cov_gvol7406u.s[27]++;
          return originIcon;
        } else {
          cov_gvol7406u.b[12][1]++;
        }

        cov_gvol7406u.s[28]++;
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: treeSelectClass('match', (cov_gvol7406u.b[13][0]++, sameCount) && (cov_gvol7406u.b[13][1]++, 'full')),
            onClick: this.handleToggle.bind(this, key),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement("span", {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 74,
              columnNumber: 11
            }
          }))
        );
      }
    }, {
      key: "handleFilter",
      value: function handleFilter(text, from) {
        cov_gvol7406u.f[5]++;

        var _ref4 = (cov_gvol7406u.s[29]++, this.props),
            onFilter = _ref4.onFilter;

        cov_gvol7406u.s[30]++;

        if (!text) {
          cov_gvol7406u.b[14][0]++;
          cov_gvol7406u.s[31]++;
          this.setState({
            tileds: []
          });
        } else {
          cov_gvol7406u.b[14][1]++;
        }

        cov_gvol7406u.s[32]++;

        if (onFilter) {
          cov_gvol7406u.b[15][0]++;
          cov_gvol7406u.s[33]++;
          onFilter(text, from);
        } else {
          cov_gvol7406u.b[15][1]++;
        }
      }
    }, {
      key: "handleToggle",
      value: function handleToggle(key, e) {
        cov_gvol7406u.f[6]++;
        cov_gvol7406u.s[34]++;
        e.stopPropagation();
        cov_gvol7406u.s[35]++;
        this.setState(immer(function (draft) {
          cov_gvol7406u.f[7]++;
          var index = (cov_gvol7406u.s[36]++, draft.tileds.indexOf(key));
          cov_gvol7406u.s[37]++;

          if (index >= 0) {
            cov_gvol7406u.b[16][0]++;
            cov_gvol7406u.s[38]++;
            draft.tileds.splice(index, 1);
          } else {
            cov_gvol7406u.b[16][1]++;
            cov_gvol7406u.s[39]++;
            draft.tileds.push(key);
          }
        }));
      }
    }, {
      key: "genRawDatum",
      value: function genRawDatum() {
        cov_gvol7406u.f[8]++;

        var _ref5 = (cov_gvol7406u.s[40]++, this.props),
            rawData = _ref5.rawData,
            _ref5$childrenKey = _ref5.childrenKey,
            childrenKey = _ref5$childrenKey === void 0 ? (cov_gvol7406u.b[17][0]++, DefaultProps.childrenKey) : _ref5$childrenKey,
            keygen = _ref5.keygen;

        cov_gvol7406u.s[41]++;
        this.rawDatum = new Datum({
          data: rawData,
          childrenKey: childrenKey,
          keygen: keygen
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_gvol7406u.f[9]++;

        var _ref6 = (cov_gvol7406u.s[42]++, this.props),
            filterText = _ref6.filterText,
            onAdvancedFilter = _ref6.onAdvancedFilter;

        var _ref7 = (cov_gvol7406u.s[43]++, this.state),
            tileds = _ref7.tileds;

        cov_gvol7406u.s[44]++;

        if ((cov_gvol7406u.b[19][0]++, !filterText) || (cov_gvol7406u.b[19][1]++, !onAdvancedFilter)) {
          cov_gvol7406u.b[18][0]++;
          cov_gvol7406u.s[45]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 104,
                columnNumber: 52
              }
            }))
          );
        } else {
          cov_gvol7406u.b[18][1]++;
        }

        var expandIcons = (cov_gvol7406u.s[46]++, [this.getIcon, this.getIcon]);
        var filterDatum = (cov_gvol7406u.s[47]++, this.getFilteredDatum());
        var data = (cov_gvol7406u.s[48]++, mergeFilteredTree(filterDatum, this.rawDatum, tileds));
        var props = (cov_gvol7406u.s[49]++, _objectSpread2(_objectSpread2({}, this.props), {}, _defineProperty({
          onFilter: this.handleFilter,
          expandIcons: expandIcons
        }, dataKey, data)));
        cov_gvol7406u.s[50]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 114,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return Tiled;
  }(Component);

  Tiled.defaultProps = DefaultProps;
  cov_gvol7406u.s[51]++;
  return Tiled;
});
cov_gvol7406u.s[52]++;
export var advancedFilterHOC = function advancedFilterHOC(Origin) {
  cov_gvol7406u.f[10]++;
  cov_gvol7406u.s[53]++;
  return function (props) {
    cov_gvol7406u.f[11]++;

    var _ref8 = (cov_gvol7406u.s[54]++, props),
        onAdvancedFilter = _ref8.onAdvancedFilter,
        onFilter = _ref8.onFilter;

    cov_gvol7406u.s[55]++;
    return (
      /*#__PURE__*/
      React.createElement(Origin, Object.assign({}, props, {
        onFilter: (cov_gvol7406u.b[20][0]++, onAdvancedFilter) || (cov_gvol7406u.b[20][1]++, onFilter),
        onAdvancedFilter: !!onAdvancedFilter,
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124,
          columnNumber: 10
        }
      }))
    );
  };
};